import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "fill"];
import React from 'react';

var UnavailableIcon = function UnavailableIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.188 18.872A9 9 0 0 0 18.872 6.188L6.188 18.872zm-1.06-1.06L17.812 5.128A9 9 0 0 0 5.128 17.812zM12 22.5C6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5 22.5 6.201 22.5 12 17.799 22.5 12 22.5z"
  }));
};

UnavailableIcon.displayName = 'UnavailableIcon';
export default UnavailableIcon;